module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/04-da567a0a1223746dc5d92c514f6162f2.jpg";